// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2v7GA","footer":"ModalCreateQualiphyProcedure_footer__2pFE3","additionData":"ModalCreateQualiphyProcedure_additionData__3D47a"};